export const ProductPageConfig = ($stateProvider) => {
  'ngInject';
  $stateProvider.state('app.productPagelisting', {
    url: '^/product-pages',
    template: '<product-pages-listing></product-pages-listing>'
  });
  $stateProvider.state('app.productPagelistingC', {
    url: '^/product-pages/:categoryId/:subCategoryId',
    template: '<product-pages-listing></product-pages-listing>'
  });
  $stateProvider.state('app.productPageAdd', {
    url: '^/product-page-add',
    template: '<product-page-add></product-page-add>'
  });
  $stateProvider.state('app.productPageEdit', {
    url: '^/product-page-edit/:id/:tabId',
    template: '<product-page-edit></product-page-edit>'
  });
  $stateProvider.state('app.categoryList', {
    url: '^/categories',
    template: '<product-page-category-list></product-page-category-list>'
  });
  $stateProvider.state('app.categoryAdd', {
    url: '^/category-add',
    template: '<category-add></category-add>'
  });
  $stateProvider.state('app.categoryEdit', {
    url: '^/category-edit/:id/:tabId',
    template: '<category-edit></category-edit>'
  });
  $stateProvider.state('app.subCategoryList', {
    url: '^/sub-categories/:parentId',
    template: '<sub-category-list></sub-category-list>'
  });
  $stateProvider.state('app.subCategoryAdd', {
    url: '^/sub-category-add',
    template: '<sub-category-add></sub-category-add>'
  });
  $stateProvider.state('app.subCategoryEdit', {
    url: '^/sub-category-edit/:id/:tabId',
    template: '<sub-category-edit></subcategory-edit>'
  });
};


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/product-page/components/product-page.config.js
 **/